<template>
  <div
    :class="[
      'item-adder d-flex justify-content-center align-items-center',
      {
        'item-adder--slim': slim,
        'item-adder--card': !slim,
        'item-adder--disabled': disabled,
        'item-adder--transparent': transparent
      }
    ]"
    @click="handleClick"
  >
    <i
      class="far fa-plus-circle item-adder__icon"
      aria-hidden="true"
      data-cy="create"
    />
    <span>{{ text }}</span>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  text?: string;
  slim?: boolean;
  disabled?: boolean;
  transparent?: boolean;
}>();

const emit = defineEmits<{
  click: [];
}>();

function handleClick() {
  if (!props.disabled) {
    emit("click");
  }
}
</script>

<style lang="scss" scoped>
.item-adder {
  cursor: pointer;
  color: var(--primary-color);
  border: 1px dashed var(--primary-color);
  border-radius: 4px;
  transition: background-color 0.15s ease;

  &:hover:not(.item-adder--disabled) {
    background-color: rgba(0, 0, 0, 0.02);
  }
}

// Full-width inline row (most common usage)
.item-adder--slim {
  width: 100%;
  padding: 0.6rem 1rem;
  background-color: transparent;
  font-weight: 500;
  font-size: 0.9rem;
  line-height: 1.2;
  flex-direction: row;
  gap: 0.375rem;

  .item-adder__icon {
    font-size: 1rem;
  }
}

// Card tile (e.g. Vendors grid)
.item-adder--card {
  width: 200px;
  height: 70%;
  min-height: 100px;
  background-color: #fff;
  font-weight: bold;
  font-size: 0.9rem;
  flex-direction: column;
  gap: 0.25rem;

  .item-adder__icon {
    font-size: 1.3rem;
  }
}

.item-adder--transparent {
  background-color: transparent;
}

.item-adder--disabled {
  border-color: var(--medium-color);
  color: var(--medium-color);
  opacity: 0.5;
  cursor: not-allowed;

  .item-adder__icon {
    color: var(--medium-color);
  }
}

.item-adder__icon {
  color: var(--primary-color);
}
</style>
